module.exports = __webpack_public_path__ + "img/forgot-password-v2.ee6baff5.svg";